import classNames from "classnames"

import styles from "./index.module.scss"

interface OrderStatusBadgeProps {
  status: string
  className?: string
}

export const OrderStatusBadge = ({ status, className }: OrderStatusBadgeProps) => {
  const type = status ? String(status) : ""
  let label = ""

  switch (type) {
    case "canceled":
      label = "Canceled"
      break

    case "confirmed":
      label = "Confirmed"
      break

    case "denied":
      label = "Denied"
      break

    case "fulfilled":
      label = "Fulfilled"
      break

    case "new":
      label = "New"
      break

    case "packed":
      label = "Packed"
      break

    case "pending":
      label = "Pending"
      break

    case "shipping":
      label = "Shipping"
      break

    default:
      label = type
      break
  }

  return (
    <span
      className={classNames(styles.orderStatus, className, {
        [styles[type]]: type ? true : false,
      })}
    >
      {label}
    </span>
  )
}
